import React from "react";

const AboutSection = () => (
  <section className="ftco-section ftc-no-pb ftc-no-pt">
    <div className="container">
      <div className="row d-flex justify-content-between">
        <div
          className="col-md-5 p-md-5"
          style={{
            backgroundImage: "url(images/bg_2.jpg)",
            backgroundPosition: "center",
            height: "650px"
          }}
        >
        </div>
        <div className="col-md-6 py-5 wrap-about pb-md-5 ftco-animate">
          <div className="heading-section heading-section-wo-line pt-md-5 mb-5">
            <div className="ml-md-0">
              <div className="sc-heading">
              <p className="first-title">BIENVENUE DANS</p>
              <h3 className="second-title">NOTRE HOTEL</h3>
            </div>
            </div>
          </div>
          <div className="pb-md-5">
            <p>
              On her way she met a copy. The copy warned the Little Blind
              Text, that where it came from it would have been rewritten a
              thousand times and everything that was left from its origin
              would be the word "and" and the Little Blind Text should turn
              around and return to its own, safe country. But nothing the
              copy said could
            </p>
            <p>
              When she reached the first hills of the Italic Mountains, she
              had a last view back on the skyline of her hometown
              Bookmarksgrove, the headline of Alphabet Village and the
              subline of her own road, the Line Lane. Pityful a rethoric
              question ran over her cheek, then she continued her way.
            </p>
            <p>
              When she reached the first hills of the Italic Mountains, she
              had a last view back on the skyline of her hometown
              Bookmarksgrove, the headline of Alphabet Village and the
              subline of her own road, the Line Lane. Pityful a rethoric
              question ran over her cheek, then she continued her way. When she reached the first hills of the Italic Mountains, she had a last view back on the.
            </p>
            <ul className="ftco-social d-flex">
              <li className="ftco-animate">
                <a href="#">
                  <span className="icon-facebook" />
                </a>
              </li>
              <li className="ftco-animate">
                <a href="#">
                  <span className="icon-instagram" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
